import React, { Component } from "react";
import { ButtonToolbar, DropdownButton, MenuItem } from "react-bootstrap";

export default class DropdownMenuSurveyLevelOfTraining extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var title = this.props.title;

        return (
            <div>
                <DropdownButton
                  bsSize    = "large"
                  title     = { title }
                  id        = "dropdown-size-large"
                  className = "dropdownWeekCaret"
                  style = {{backgroundColor: "#fff",  fontSize:18}}
                  onSelect={(eventKey) => this.props.handle(eventKey)}
                >
                    <MenuItem eventKey="1">1. I feel undertrained and ready for more!</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="2">2. Feel ok, but want more.</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="3">3. Feel good and activated.</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="4">4. Feel great; trained just beyond my limits </MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="5">5. I feel poor - like we pushed well beyond my limits. </MenuItem>
                </DropdownButton>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/DropdownMenuSurveyLevelOfTraining.js